/* unplugin-vue-components disabled */import script from "./NewDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewDetails.vue?vue&type=script&setup=true&lang=ts"

import "./NewDetails.vue?vue&type=style&index=0&id=153192c2&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153192c2"]])

export default __exports__